module.exports = __webpack_public_path__ + "img/美容水(蓝)_01.35eadfc2.jpg";